import Vue from 'vue';
import appConfig from './app.config';

const { API_HOST } = appConfig;

const Api = {
  app: {
    config() {
      return Vue.axios.get(`${API_HOST}/config`);
    },
    jsSdk(params = {}) {
      return Vue.axios.get(`${API_HOST}/js-sdk-config`, { params });
    },
    // 获取地区列表
    district() {
      return Vue.axios.get(`${API_HOST}/district`);
    },
    // 获取邮局列表
    postOffice(params = {}) {
      return Vue.axios.get(`${API_HOST}/post-office`, { params });
    },
    // 获取商品分类
    productCategories() {
      return Vue.axios.get(`${API_HOST}/product-categories`);
    },
    notifications(params = {}) {
      return Vue.axios.get(`${API_HOST}/system-information`, { params });
    },
    terms() {
      return Vue.axios.get(`${API_HOST}/delivery-terms`);
    },
    privacy() {
      return Vue.axios.get(`${API_HOST}/privacy-policy`);
    },
    tracking(tracking_no) {
      return Vue.axios.get(`${API_HOST}/parcel-tracking/${tracking_no}`);
    },
    cs() {
      return Vue.axios.get(`${API_HOST}/cs`);
    },
    parcelModel() {
      return Vue.axios.get(`${API_HOST}/parcel-model`);
    },
    joinRequest(params) {
      return Vue.axios.post(`${API_HOST}/join-us`, params);
    },
  },
};

export default function plugin(_Vue) {
  if (plugin.installed) {
    return;
  }
  plugin.installed = true;

  Object.defineProperty(_Vue.prototype, '$api', {
    get() {
      return Api;
    },
  });
}

export {
  Api,
};
